const INITIAL_STATE = {
    userCache: {}
};

const SMSReducers = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case 'SMS_CACHE_USER_INFO':
            return {
                ...state,
                userCache: {
                    ...state.userCache,
                    [action.phone]: action.userInfo
                }
            };
        default:
            return state;
    }
};

export default SMSReducers;
